import {createReducer, on} from '@ngrx/store';
import {overviewStateInitial} from './overview.state.initial';
import {OverviewActions} from './overview.actions';


export const overviewReducer = createReducer(
  overviewStateInitial,

  on(
    OverviewActions.readNews,
    (state) => ({
      ...state,
      loading: true,
    }),
  ),

  on(
    OverviewActions.readNewsSuccess,
    (state, {newsDtos, totalElements}) => ({
      ...state,
      newsIds: newsDtos.filter(newsDto => !!newsDto.id).map(newsDto => newsDto.id!),
      totalElements: totalElements,
      loaded: true,
      loading: false,
    }),
  ),

  on(
    OverviewActions.changePageable,
    (state, {pageableDto}) => ({
      ...state,
      pageableDto,
    }),
  ),

);
